export default "__VITE_ASSET__D0sklA1$__"